import {
  withCompInfo,
  createComponentMapperModel,
} from '@wix/editor-elements-integrations';
import {
  getWidthInPixels,
  resolveInheritanceChain,
  withFallbackValues,
  withSiteDirection,
} from '@wix/editor-elements-common-utils';
import { ariaLabels, TranslationKeys } from '../constants';
import type { RangeSliderCSSVars } from '../RangeSlider.types';

const sliderDirectionFallbackConfig = {
  targetNamespace: 'compData' as const,
  fields: [{ source: 'direction', target: 'sliderDirection' }],
};

// TODO add types
const props = withCompInfo<any, any>()(
  [
    'compData',
    'compProps',
    'compLayout',
    'compSingleLayout',
    'isOneDocMigrated',
    'compStylableClass',
    'translate',
    'directionWithOptInRtlSupport',
  ],
  ({
    compData,
    compProps,
    compLayout,
    compSingleLayout,
    isOneDocMigrated,
    compStylableClass,
    translate,
    directionWithOptInRtlSupport,
  }) => {
    const widthInPixels = isOneDocMigrated
      ? getWidthInPixels(compSingleLayout)
      : compLayout.width;

    const { sliderDirection, rootDirection } = compData;
    return {
      ...compData,
      ...compProps,
      resolvedSliderDirection: resolveInheritanceChain(
        [sliderDirection, rootDirection],
        directionWithOptInRtlSupport,
      ),
      stylableClassName: compStylableClass,
      width: widthInPixels,
      translations: {
        minValueAriaLabel:
          translate(
            ariaLabels.ariaNamespace,
            TranslationKeys.minValueAriaLabel,
          ) || ariaLabels.ariaDefaultMinValueLabel,
        maxValueAriaLabel:
          translate(
            ariaLabels.ariaNamespace,
            TranslationKeys.maxValueAriaLabel,
          ) || ariaLabels.ariaDefaultMaxValueLabel,
      },
    };
  },
  [withFallbackValues([sliderDirectionFallbackConfig])],
);

const css = withCompInfo<RangeSliderCSSVars, any>()(
  ['compData', 'compProps'],
  ({ compData, compProps }) => {
    const {
      rootDirection = 'inherit',
      labelDirection = 'inherit',
      sliderDirection = 'inherit',
    } = compData;

    const { align } = compProps;

    return {
      '--root-direction': withSiteDirection(rootDirection),
      '--label-direction': labelDirection,
      '--slider-direction': sliderDirection,
      '--align': align,
    };
  },
  [withFallbackValues([sliderDirectionFallbackConfig])],
);

export default createComponentMapperModel({
  props,
  css,
});
